/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SavingProductGroupResponseDto { 
    id?: number;
    name?: string | null;
    description?: string | null;
    numberOfContributionPerCycle?: number;
    memberCapacity?: number;
    recurringSavingAmount?: number;
    recurringSavingPeriodTypeId?: number;
    savingPeriodType?: string | null;
    recurringSavingPeriodType?: string | null;
    savingProductType?: string | null;
    interestCompoundingPeriod?: string | null;
    interestPostingPeriod?: string | null;
    interestCalculationType?: string | null;
    priorNotificationDays?: number;
    isPublic?: boolean;
}

